import React from 'react';

const StatisticIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40.001"
    height="36.001"
    viewBox="0 0 40.001 36.001"
  >
    <path
      id="Union_3"
      data-name="Union 3"
      d="M-3978,36a5.008,5.008,0,0,1-5-5V5a5.007,5.007,0,0,1,5-5h30a5.006,5.006,0,0,1,5,5V31a5.007,5.007,0,0,1-5,5Zm33-5v0Zm-16-14V27a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-9v-.586l3-3,1.293,1.293A.993.993,0,0,0-3954,24a1,1,0,0,0,.708-.293l4-4A1,1,0,0,0-3949,19a.992.992,0,0,0-.293-.707A.99.99,0,0,0-3950,18a.99.99,0,0,0-.707.294L-3954,21.586l-1.292-1.292A.993.993,0,0,0-3956,20a.99.99,0,0,0-.707.294L-3959,22.586V17a1,1,0,0,0-1-1A1,1,0,0,0-3961,17Zm-14,3a3.952,3.952,0,0,0,.889,2.484A5.019,5.019,0,0,0-3977,27a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1,5.021,5.021,0,0,0-2.889-4.516A3.957,3.957,0,0,0-3967,20a4,4,0,0,0-4-4A4,4,0,0,0-3975,20Zm-6-15V8h36V5a3,3,0,0,0-3-3h-30A3,3,0,0,0-3981,5Zm13.827,21h-7.657A3.006,3.006,0,0,1-3972,24h2a3.006,3.006,0,0,1,2.828,2v0ZM-3973,20a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-3973,20Zm1-14a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm-6,0a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z"
      transform="translate(3983)"
    />
  </svg>
);

export default StatisticIcon;
